
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ParameterHierarchyGuide extends Vue {
  @Prop({ default: 'global' })
  public currentLevel!: 'global' | 'supplier' | 'product';

  public handleLevelClick(level: 'global' | 'supplier' | 'product') {
    this.$emit('level-click', level);
  }
}
